export default __webpack_public_path__ + "dfc6d7c8ab34dca34f351b95d4ea15ad.png";